import styled from 'styled-components'

import ContentBox from '../../components/ContentBox'
import { default as Cal } from '../../components/Calendar'
import { default as SlotsS } from '../../components/Slots'
import ActionButton from '../../components/ActionButton'
import FormErrors from '../../components/form/FormErrors'
import TitleDescription from '../../components/TitleDescription'
import breakpoints from '../../theme/breakpoints'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const TitleDescriptionStyled = styled(TitleDescription)`
  > *:not(img) {
    padding: 0 12px;
  }

  ${breakpoints.up('tablet')} {
    > *:not(img) {
      padding: 0 72px;
    }
  }
`

export const Box = styled(ContentBox)`
  padding: 0;
`

export const FormContentBox = styled(ContentBox)`
  flex-grow: 1;
`

export const Calendar = styled(Cal)``

export const Slots = styled(SlotsS)`
  margin-top: 36px;
`

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`

export const Button = styled(ActionButton)`
  margin-top: 36px;
  align-self: center;
`

export const Errors = styled(FormErrors)`
  text-align: center;
  margin-top: 26px;
`
